import { Popover, List, useTheme } from '@mui/material'
import { ListItem } from '../../subComponent'
import { LearnIcon, MapIcon } from '../../../icons'

interface SidebarPopoverProps {
  open: boolean
  onClose: () => void
  selectedIndex: number
  onListItemClick: (index: number) => void
}

export const SidebarMobilePopover = ({
  open,
  onClose,
  selectedIndex,
  onListItemClick,
}: SidebarPopoverProps) => {
  const theme = useTheme()

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={{
        top: 68,
        left: 30,
      }}
      sx={{
        '& .MuiPaper-root': {
          width: 272,
          borderRadius: '16px',
          boxShadow: theme.shadows[2],
          mt: 1,
        },
      }}
    >
      <List sx={{ px: 2 }}>
        <ListItem
          index={0}
          selectedIndex={selectedIndex}
          onClick={onListItemClick}
          icon={<MapIcon sx={{ color: 'transparent' }} />}
          label="Water quality map"
        />
        <ListItem
          index={1}
          selectedIndex={selectedIndex}
          onClick={onListItemClick}
          icon={<LearnIcon sx={{ color: 'transparent' }} />}
          label="Learn"
        />
      </List>
    </Popover>
  )
}